import { render, staticRenderFns } from "./SoliInstruments.vue?vue&type=template&id=128f9328&scoped=true"
import script from "./SoliInstruments.vue?vue&type=script&lang=js"
export * from "./SoliInstruments.vue?vue&type=script&lang=js"
import style0 from "./SoliInstruments.vue?vue&type=style&index=0&id=128f9328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f9328",
  null
  
)

export default component.exports